import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminAllCountries from "../../Components/Admin/AdminAllCountries";
import SideBar from "../../Components/Admin/SideBar";

const AdminAllCountriesPage = () => {
  return (
    <AdminAllCountries />
  );
};

export default AdminAllCountriesPage;
